import exportData from '../../../Services/export'

export default () => (dispatch) => {

  dispatch(exportData())

}
